/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineClassModulesId200,
  GetApiV1ClassroomdisciplineClassModulesId401,
  GetApiV1ClassroomdisciplineClassModulesId404,
  GetApiV1ClassroomdisciplineClassModulesId500,
  GetApiV1ClassroomdisciplineClassModulesIdPathParams,
  GetApiV1ClassroomdisciplineClassModulesIdQueryResponse,
} from "../../types/classPlanningClassModuleController/GetApiV1ClassroomdisciplineClassModulesId.ts";
import { classModuleDetailViewModelSchema } from "../classModuleDetailViewModelSchema.ts";

export const getApiV1ClassroomdisciplineClassModulesIdPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1ClassroomdisciplineClassModulesIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineClassModulesId200Schema = z.lazy(
  () => classModuleDetailViewModelSchema,
) as unknown as ToZod<GetApiV1ClassroomdisciplineClassModulesId200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineClassModulesId401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineClassModulesId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ClassroomdisciplineClassModulesId404Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineClassModulesId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ClassroomdisciplineClassModulesId500Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineClassModulesId500>;

export const getApiV1ClassroomdisciplineClassModulesIdQueryResponseSchema =
  z.lazy(
    () => getApiV1ClassroomdisciplineClassModulesId200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineClassModulesIdQueryResponse>;
